import styled from "styled-components";

export const ButtonWhatsApp = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  opacity: 1;
  transition: transform 0.3s;
  background: transparent;
  border: 0;
  cursor: pointer;
  z-index: 9999;

  &:hover {
    transform: translateY(-5px);
  }

  img {
    height: 60px;
  }
`;
